import { StateCreator } from 'zustand';
import { ICartData } from './cartData.interface';

export const cartDataSlice: StateCreator<ICartData> = (set) => ({
  cartData: {},
  initializedCartId: null,
  setCartData(data: Record<string, any>) {
    set(() => ({ cartData: data }));
  },
  setInitializedCartId(cartId: string) {
    set(() => ({ initializedCartId: cartId }));
  },
});
